import { FlowsheetConstants } from "@/Flowsheets/FlowsheetConstants";
import { CareElementFrequencyType } from "../CareElementFrequencyType";
import { CareElementOperatorType } from "../CareElementOperatorType";
import { BaseCareElementConfig } from "./BaseCareElementConfig";
import { CareComponentConfig } from "./CareComponentConfig";
import { CareElementType } from "./CareElementType";
import { FlowsheetConfig } from "./FlowsheetConfig";
import { FrequencyCareElementConfig } from "./FrequencyCareElementConfig";
import { LabResultsCareElementConfig } from "./LabResultsCareElementConfig";
import { ReviewedCareElementConfig } from "./ReviewedCareElementConfig";
import { VitalSignsCareElementConfig } from "./VitalSignsCareElementConfig";

const defaultConfiguration: FlowsheetConfig = {
    CareComponents: [
        new CareComponentConfig({
            Name: FlowsheetConstants.LabResults.CareComponentName,
            CareElementsConfig: [
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.HBA1cCareElementName, StandardCode: "STD_HBA1C", Frequency: CareElementFrequencyType.ThreeMonths, TargetRange: { LowerBound: 7.0 }, Operator: CareElementOperatorType.LessThanOrEqualTo }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.HDLCareElementName, StandardCode: "STD_HDL", Frequency: CareElementFrequencyType.Annual }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.LDLCareElementName, StandardCode: "STD_LDL", Frequency: CareElementFrequencyType.Annual, TargetRange: { LowerBound: 2.0 }, Operator: CareElementOperatorType.LessThanOrEqualTo }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.CHOLHDLCareElementName, StandardCode: "STD_CHOLHDL", Frequency: CareElementFrequencyType.Annual, TargetRange: { LowerBound: 4.0 }, Operator: CareElementOperatorType.LessThan }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.TGCareElementName, StandardCode: "STD_TG", Frequency: CareElementFrequencyType.Annual, TargetRange: { LowerBound: 2.0 }, Operator: CareElementOperatorType.LessThan }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.AlbuminCreatinineCareElementName, StandardCode: "STD_AlbuminCreatinineRatio", Frequency: CareElementFrequencyType.Annual, TargetRange: { LowerBound: 2.0 }, Operator: CareElementOperatorType.LessThan }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.FPGCareElementName, StandardCode: "LOIC_14771-0", Frequency: CareElementFrequencyType.ThreeMonths, TargetRange: { LowerBound: 4, UpperBound: 7 }, Operator: CareElementOperatorType.Between }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.GlucoseCareElementName, StandardCode: "LOINC_14995-5", Frequency: CareElementFrequencyType.ThreeMonths, TargetRange: { LowerBound: 5, UpperBound: 10 }, Operator: CareElementOperatorType.Between }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.EGFRCareElementName, StandardCode: "STD_eGFR", Frequency: CareElementFrequencyType.Annual }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.AlbuminCareElementName, StandardCode: "STD_AlbuminUrine" }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.NaCareElementName, StandardCode: "STD_NA" }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.KCareElementName, StandardCode: "STD_K" }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.CreatinineCareElementName, StandardCode: "STD_Cr" }),
                new LabResultsCareElementConfig({ Name: FlowsheetConstants.LabResults.O2SaturationCareElementName, StandardCode: "LOINC_2708-6" })
            ]
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.VitalSigns.CareComponentName,
            CareElementsConfig: [
                new VitalSignsCareElementConfig({ Name: FlowsheetConstants.VitalSigns.BloodPressureCareElementName, Frequency: CareElementFrequencyType.ThreeMonths, TargetRange: { LowerBound: 130, UpperBound: 80 }, Operator: CareElementOperatorType.LessThan }),
                new VitalSignsCareElementConfig({ Name: FlowsheetConstants.VitalSigns.BodyMassIndexCareElementName, Frequency: CareElementFrequencyType.ThreeMonths, TargetRange: { LowerBound: 18.5, UpperBound: 24.9 }, Operator: CareElementOperatorType.Between }),
                new VitalSignsCareElementConfig({ Name: FlowsheetConstants.VitalSigns.WaistCircumferenceCareElementName, Frequency: CareElementFrequencyType.ThreeMonths, TargetRange: { LowerBound: 102 }, Operator: CareElementOperatorType.LessThanOrEqualTo }),
                new VitalSignsCareElementConfig({ Name: FlowsheetConstants.VitalSigns.HeightCareElementName }),
                new VitalSignsCareElementConfig({ Name: FlowsheetConstants.VitalSigns.WeightCareElementName }),
                new VitalSignsCareElementConfig({ Name: FlowsheetConstants.VitalSigns.HeartRateCareElementName })
            ]
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.HeartFailureBasic.CareComponentName,
            CareElementsConfig: [
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.FatiguePerWeekCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.DizzinessOrSyncopePerWeekCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.DyspneaOnExertionPerWeekCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.DyspneaAtRestPerWeekCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.OrthopneaPerWeekCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.ParoxysmalNocturnalDyspneaPerWeekCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.NewYorkHeartAssociationFunctionalCapacityClassificationCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.TextReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.MedicationReviewCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.JugularVenousPressureElevationCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.PittingEdemaCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanTextReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.LungCracklesCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanTextReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.WheezingCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanTextReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SignsOfPharmacologicalIntoleranceCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PhysicalExamination.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PatientSelfManagement.NumberOfERVisitsSinceLastAssessmentCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.IntegerReviewed,
                    Target: 0,
                    Operator: CareElementOperatorType.EqualTo,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PatientSelfManagement.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PatientSelfManagement.EducationSelfManagementTrainingCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.MultiSelectReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PatientSelfManagement.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PatientSelfManagement.TargetModifiableRiskFactorsForHeartFailureAndCoronaryArteryDiseaseCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.MultiSelectReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PatientSelfManagement.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementFirstLine.AngiotensinConvertingEnzymeInhibitorCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.FirstLineReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementFirstLine.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementFirstLine.BetaBlockerCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.FirstLineReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementFirstLine.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementFirstLine.AngiotensinReceptorBlockerIfAngiotensinConvertingEnzymeInhibitorIntolerantCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.FirstLineReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementFirstLine.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementSymptomRelief.LoopDiureticMinimumEffectiveDoseCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.AgentDoseReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementSymptomRelief.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementSymptomRelief.SpironolactoneDoseCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.TextReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementSymptomRelief.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementSymptomRelief.DigoxinDoseCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.TextReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementSymptomRelief.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementPreventative.ConsiderAcetylsalicylicAcidCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.TextReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementPreventative.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementPreventative.AnticoagulantTherapyCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.AgentDoseReviewed,
                    SubSectionName: FlowsheetConstants.HeartFailureBasic.PharmacologicManagementPreventative.SubSectionName
                })
            ]
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.DiabetesBasic.CareComponentName,
            CareElementsConfig: [
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.DiabetesBasic.GlucoseMonitoring.SelfMonitoringBloodGlucoseCareElementName,
                    Frequency: CareElementFrequencyType.ThreeMonths,
                    CareElementType: CareElementType.BooleanReviewed,
                    Target: true,
                    Operator: CareElementOperatorType.EqualTo,
                    SubSectionName: FlowsheetConstants.DiabetesBasic.GlucoseMonitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.DiabetesBasic.GlucoseMonitoring.NumberOfHypoglycemicEpisodesCareElementName,
                    Frequency: CareElementFrequencyType.ThreeMonths,
                    CareElementType: CareElementType.IntegerReviewed,
                    Target: 0,
                    Operator: CareElementOperatorType.EqualTo,
                    SubSectionName: FlowsheetConstants.DiabetesBasic.GlucoseMonitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.DiabetesBasic.GlucoseMonitoring.FastingGlucoseMonitorLabResultComparisonCalibratedCareElementName,
                    Frequency: CareElementFrequencyType.Annual,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.DiabetesBasic.GlucoseMonitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.DiabetesBasic.Complications.ElectrocardiogramCareElementName,
                    Frequency: CareElementFrequencyType.Annual,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.DiabetesBasic.Complications.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.DiabetesBasic.Complications.AcetylsalicylicAcidUseCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.DiabetesBasic.Complications.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.DiabetesBasic.Complications.PsychosocialScreeningCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.DiabetesBasic.Complications.SubSectionName
                })
            ]
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.CareComponentName,
            CareElementsConfig: [
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.AssessmentAndMonitoring.ChronicObstructivePulmonaryDiseaseClassification,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.AssessmentAndMonitoring.SubSectionName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.TextReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.AssessmentAndMonitoring.Exacerbations,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.AssessmentAndMonitoring.SubSectionName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.IntegerReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.AssessmentAndMonitoring.LastExacerbationDate,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.AssessmentAndMonitoring.SubSectionName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.DateOnlyReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.AssessmentAndMonitoring.SpirometryTest,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.AssessmentAndMonitoring.SubSectionName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.AssessmentAndMonitoring.NeedForSupplementalOxygen,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.AssessmentAndMonitoring.SubSectionName,
                    Frequency: CareElementFrequencyType.Annual,
                    CareElementType: CareElementType.BooleanReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.AssessmentAndMonitoring.NeedForNocturnalVentilation,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.AssessmentAndMonitoring.SubSectionName,
                    Frequency: CareElementFrequencyType.Annual,
                    CareElementType: CareElementType.BooleanReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.DiagnosticsTests.ArterialBloodGasTest,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.DiagnosticsTests.SubSectionName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.TextReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.TreatmentAndManagement.MedicationTopicReviewed,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.TreatmentAndManagement.SubSectionName,
                    Frequency: CareElementFrequencyType.SixMonths,
                    CareElementType: CareElementType.BooleanReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.TreatmentAndManagement.PathophysiologyPrognosisTreatmentTopicReviewed,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.TreatmentAndManagement.SubSectionName,
                    Frequency: CareElementFrequencyType.SixMonths,
                    CareElementType: CareElementType.BooleanReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.TreatmentAndManagement.ExacerbationPlan,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.TreatmentAndManagement.SubSectionName,
                    Frequency: CareElementFrequencyType.SixMonths,
                    CareElementType: CareElementType.BooleanReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.PatientEducation.SmokingCessationTopicReviewed,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.PatientEducation.SubSectionName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.PatientEducation.SmokingCessationProgramTopicReviewed,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.PatientEducation.SubSectionName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.PatientEducation.PulmonaryRehabilitationTopicReviewed,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.PatientEducation.SubSectionName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.PatientEducation.ProvidePatientEducationTopicReviewed,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.PatientEducation.SubSectionName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.PatientEducation.SpecialistReferralTopicReviewed,
                    SubSectionName: FlowsheetConstants.ChronicObstructivePulmonaryDiseaseBasic.PatientEducation.SubSectionName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed
                })
            ]
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.HypertensionBasic.CareComponentName,
            CareElementsConfig: [
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.HypertensionBasic.TenYearCoronaryArteryDiseaseRiskCareElementName, Frequency: null, CareElementType: CareElementType.DecimalReviewed }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.HypertensionBasic.MedicationReviewedCareElementName, Frequency: null, CareElementType: CareElementType.BooleanReviewed }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.HypertensionBasic.ExerciseReviewedCareElementName, Frequency: null, CareElementType: CareElementType.BooleanReviewed }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.HypertensionBasic.SaltIntakeReviewedCareElementName, Frequency: null, CareElementType: CareElementType.BooleanReviewed })
            ]
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.AsthmaBasic.CareComponentName,
            CareElementsConfig: [
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.SymptomsOfAsthma.DyspneaCareElementName,
                    Frequency: null,
                    Target: 4,
                    Operator: CareElementOperatorType.LessThan,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.SymptomsOfAsthma.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.SymptomsOfAsthma.CoughCareElementName,
                    Frequency: null,
                    Target: 4,
                    Operator: CareElementOperatorType.LessThan,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.SymptomsOfAsthma.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.SymptomsOfAsthma.WheezeCareElementName,
                    Frequency: null,
                    Target: 4,
                    Operator: CareElementOperatorType.LessThan,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.SymptomsOfAsthma.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.SymptomsOfAsthma.ChestTightnessCareElementName,
                    Frequency: null,
                    Target: 4,
                    Operator: CareElementOperatorType.LessThan,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.SymptomsOfAsthma.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.SymptomsOfAsthma.NightTimeSymptomsCareElementName,
                    Frequency: null,
                    Target: 0,
                    Operator: CareElementOperatorType.EqualTo,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.SymptomsOfAsthma.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Exacerbations.ExacerbationsCareElementName,
                    Frequency: null,
                    Target: 0,
                    Operator: CareElementOperatorType.EqualTo,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Exacerbations.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.SpirometryTestCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.SchoolWorkAbsenceCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.NumberOfSchoolWorkAbsenceCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    Target: 0,
                    Operator: CareElementOperatorType.EqualTo,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.LimitsPhysicalActivityCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.RelieverUseCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    Target: 2,
                    Operator: CareElementOperatorType.LessThan,
                    CareElementType: CareElementType.IntegerReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.MedicationReviewedCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.SmokingCessationDiscussedCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.OptimalDeviceTechniqueReviewCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.EducationReferralCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.SpecialistReferralCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.EnvironmentalControlCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.CopingStrategiesCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.TriggerAvoidanceCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.DefinitionReviewCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.BooleanReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                }),
                new ReviewedCareElementConfig({
                    Name: FlowsheetConstants.AsthmaBasic.Monitoring.ActionPlanCareElementName,
                    Frequency: CareElementFrequencyType.None,
                    CareElementType: CareElementType.MultiSelectReviewed,
                    SubSectionName: FlowsheetConstants.AsthmaBasic.Monitoring.SubSectionName
                })
            ]
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.Medication.CareComponentName,
            CareElementsConfig: []
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.Immunizations.CareComponentName,
            CareElementsConfig: [
                new FrequencyCareElementConfig({
                    Name: FlowsheetConstants.Immunizations.InfluenzaCareElementName,
                    CareElementType: CareElementType.Immunization,
                    Frequency: CareElementFrequencyType.Annual
                }),
                new FrequencyCareElementConfig({
                    Name: FlowsheetConstants.Immunizations.PneumococcalCareElementName,
                    CareElementType: CareElementType.Immunization,
                    Frequency: null
                })
            ]
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.RiskFactors.CareComponentName,
            CareElementsConfig: [
                new BaseCareElementConfig({
                    Name: FlowsheetConstants.RiskFactors.SmokingStatusCareElementName,
                    CareElementType: CareElementType.RiskFactor
                }),
                new BaseCareElementConfig({
                    Name: FlowsheetConstants.RiskFactors.AlcoholUseCareElementName,
                    CareElementType: CareElementType.RiskFactor
                }),
                new FrequencyCareElementConfig({
                    Name: FlowsheetConstants.RiskFactors.ErectileFunctionCareElementName,
                    Frequency: null,
                    CareElementType: CareElementType.RiskFactor
                })
            ]
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.Screening.CareComponentName,
            CareElementsConfig: [
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.Screening.DilatedEyeCareElementName, CareElementType: CareElementType.BooleanReviewed, Frequency: CareElementFrequencyType.Annual }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.Screening.FootCareElementName, CareElementType: CareElementType.Subject, Frequency: CareElementFrequencyType.Annual }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.Screening.NeurologicalCareElementName, CareElementType: CareElementType.Subject, Frequency: CareElementFrequencyType.Annual })
            ]
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.CounselingAndEducation.CareComponentName,
            CareElementsConfig: [
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.CounselingAndEducation.SmokingCessationCareElementName, Frequency: CareElementFrequencyType.ThreeMonths, CareElementType: CareElementType.BooleanReviewed }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.CounselingAndEducation.NutritionCareElementName, Frequency: CareElementFrequencyType.ThreeMonths, CareElementType: CareElementType.BooleanReviewed }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.CounselingAndEducation.ExerciseCareElementName, Frequency: CareElementFrequencyType.ThreeMonths, CareElementType: CareElementType.BooleanReviewed }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.CounselingAndEducation.ImmunizationCareElementName, Frequency: CareElementFrequencyType.ThreeMonths, CareElementType: CareElementType.BooleanReviewed }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.CounselingAndEducation.OtherCareElementName, Frequency: CareElementFrequencyType.ThreeMonths, CareElementType: CareElementType.BooleanReviewed }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.CounselingAndEducation.NutritionLipidsCareElementName, Frequency: CareElementFrequencyType.Annual, CareElementType: CareElementType.BooleanReviewed }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.CounselingAndEducation.NutritionDiabetesCareElementName, Frequency: CareElementFrequencyType.Annual, CareElementType: CareElementType.BooleanReviewed }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.CounselingAndEducation.DiabetesCareElementName, Frequency: CareElementFrequencyType.Annual, CareElementType: CareElementType.BooleanReviewed })
            ]
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.Spirometry.CareComponentName,
            CareElementsConfig: []
        }),
        new CareComponentConfig({
            Name: FlowsheetConstants.SelfManagementPlan.CareComponentName,
            CareElementsConfig: [
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.SelfManagementPlan.CollaborativeSelfManagementGoalsCareElementName, Frequency: null, CareElementType: CareElementType.TextReviewed }),
                new ReviewedCareElementConfig({ Name: FlowsheetConstants.SelfManagementPlan.SelfManagementChallengesCareElementName, Frequency: null, CareElementType: CareElementType.TextReviewed })
            ]
        })
    ]
};

export { defaultConfiguration };
